import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { compose, setDisplayName } from 'recompose';

import { withOperationsStatus } from 'features/apolloOperationsObserver';

const defaultOptions = { delay: 0 };

const operationToId = operation => {
  const vars = get(operation, 'variables');

  return vars ? JSON.stringify(vars) : undefined;
};

export default options => WrappedComponent =>
  compose(
    setDisplayName('withTireOptionsLoadingObserver'),
    withOperationsStatus('tiresOptions', 'opStatus', operationToId),
  )(
    class WithTireOptionsLoadingObserverWrapper extends Component {
      static propTypes = {
        opStatus: PropTypes.shape({
          id: PropTypes.string.isRequired,
          isLoading: PropTypes.bool.isRequired,
        }),
      };

      static defaultProps = { opStatus: undefined };

      constructor(props) {
        super(props);

        this.count = 0;
        this.listeners = new Set();

        this.update(props);
      }

      componentWillReceiveProps(nextProps) {
        this.update(nextProps);
      }

      componentWillUnmount() {
        clearTimeout(this.triggerTimeout);
        this.listeners.clear();
      }

      update = props => {
        const { opStatus = {} } = props;
        const { id, isLoading = false } = opStatus;
        const opts = { ...defaultOptions, ...options };

        if (id) {
          const prevCount = this.count;
          this.count = Math.max(0, this.count + (isLoading ? 1 : -1));

          if (this.count !== prevCount && this.count === 0) {
            const listeners = Array.from(this.listeners.values());
            const trigger = () => listeners.forEach(fn => fn());

            opts.delay
              ? (this.triggerTimeout = setTimeout(trigger, opts.delay))
              : trigger();
          }
        }
      };

      addListener = cb => {
        this.listeners.add(cb);

        return () => this.listeners.delete(cb);
      };

      render() {
        const { opStatus, ...rest } = this.props;
        return (
          <WrappedComponent
            {...rest}
            addAllTireOptionsLoadedListener={this.addListener}
          />
        );
      }
    },
  );



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/withTireOptionsLoadingObserver.js